import { useMemo } from 'react';
import type { CARD_COLORS } from '../components/CommonCard';
import { calculateTogo } from '../lib/togo';

export const useCalculateTogo = (
    gameType: 75 | 80 | 90 | 30,
    cardNumbers: number[],
    patterns: number[][],
    matches: number,
    called: number[],
    currentPart: number,
    hasFreeSpace: boolean,
    confirmedWinner = false
) => {
    return useMemo(() => {
        const result = calculateTogo(
            gameType,
            cardNumbers,
            patterns,
            matches,
            called,
            hasFreeSpace
        );
        const types: Record<number, keyof typeof CARD_COLORS> = {
            1: 'oneTG',
            2: 'twoTG',
            3: 'threeTG',
        };
        const cardType: keyof typeof CARD_COLORS = confirmedWinner
            ? 'winner'
            : types[result.togo] || 'default';
        return {
            cardType,
            lastNumber: confirmedWinner ? [] : result.lastNumber,
        };
    }, [
        gameType,
        cardNumbers,
        patterns,
        matches,
        called,
        currentPart,
        hasFreeSpace,
        confirmedWinner,
    ]);
};
